const B_1 = [
    {
        title: '招标项目流程',
        path: '/bidding/liucheng/index'
    }
]

export default {
    path: 'index',
    component: () => import(/*webpackChunkName: 'liu-cheng'*/ '@layout/empty'),
    children: [
        {
            path:"",
            component: () => import('@views/bidding/views/liu-cheng/index'),
            meta: {
                title: '招标项目流程',
                bread: B_1
            },
        }
    ]
}
